<template>
    <div id="project-tools">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item">Proyectos</li>
                <li class="breadcrumb-item active">Herramientas</li>
            </ol>
        </nav>
        <div class="container-fluid">
            <div class="row">
                <div class="col-sm-12 col-md-6 col-lg-6">
                    <vx-card title="Probar Contratos">
                        <div class="row">
                            <div class="col-md-3 col-sm-12">
                                <label for="id" class="bold black">PID:</label>
                                <vs-input name="id" class="w-full" v-model.number="pid"/>
                            </div>
                            <div class="col-md-6 col-sm-12">
                                <label for="id" class="bold black">Contrato:</label>
                                <vs-select
                                    v-model.number="contrato"
                                    class="w-full select-large"
                                    v-validate="'required'"
                                    name="contract"
                                    placeholder="Seleccione una opción">
                                    
                                    <vs-select-item
                                    :key="index"
                                    :value="item.type"
                                    :text="item.text"
                                    v-for="(item,index) in contractOptions"
                                    class="w-full"
                                    />
                                </vs-select>
                            </div>
                            <div class="col-md-3 col-sm-12">
                                <vs-button style="margin-top: 2rem;" color="warning" size="small" @click="verContrato()">Generar</vs-button>
                            </div>
                        </div>
                    </vx-card>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

const contractOptions = [
    { type: 1, text: "Compra-venta"}
    ,{ type: 2, text: "Crédito Simple"}
    ,{ type: 3, text: "Prenda"}
    ,{ type: 4, text: "Pagaré"}
    ,{ type: 22, text: "Carta Entendimiento"}
    ,{ type: 5, text: "FASES Crédito Simple"}
    ,{ type: 6, text: "FASES CS Anexo 1"}
    ,{ type: 7, text: "FASES CS Anexo 4"}
    ,{ type: 8, text: "FASES CompraVenta"}
    ,{ type: 9, text: "FASES Pagaré"}
    ,{ type: 10, text: "FASES Prenda"}
    ,{ type: 11, text: "FASES CompraVenta Anexo 1"}
    ,{ type: 12, text: "FASES Prenda Anexo 1"}
    ,{ type: 13, text: "FASES Prenda Anexo 2"}
    ,{ type: 29, text: "Grupo 1 ver.03/2022"}
    ,{ type: 30, text: "Grupo 1 ver.05/2022"}
    ,{ type: 23, text: "Grupo 1 ver.03/2021"}
    ,{ type: 27, text: "Grupo 1 ver.12/2021"}
    ,{ type: 14, text: "Grupo 1 ver.12/2020"}
    ,{ type: 15, text: "Grupo 2 ver.12/2020"}
    ,{ type: 16, text: "Grupo 3 ver.12/2020"}
    ,{ type: 17, text: "Grupo 4 ver.12/2020"}
    ,{ type: 24, text: "XML Grupo 1 ver.03/2021"}
    ,{ type: 28, text: "XML Grupo 1 ver.12/2021"}
    ,{ type: 18, text: "XML Grupo 1 ver.12/2020"}
    ,{ type: 19, text: "XML Grupo 2 ver.12/2020"}
    ,{ type: 20, text: "XML Grupo 3 ver.12/2020"}
    ,{ type: 21, text: "XML Grupo 4 ver.12/2020"}
    ,{ type: 25, text: "Comisión mercantil proveedor"}
    ,{ type: 26, text: "XML Comisión mercantil proveedor"}
];
export default {
    data(){
        return {
            pid: 0
            , contrato: 0
            , contractOptions: contractOptions
        }
    },
    methods: {
        verContrato(){
            if(this.pid > 0 && this.contrato >= 1 && this.contrato <= 30){
                this.$vs.notify({title:'Cargando...',text:'Espere un momento',color:'dark',position:'bottom-center',icon:'access_time'})
                axios.get( '/api/contratoPrueba/'+this.contrato+'/'+this.pid).then((resolve) => {
                    this.$vs.notify({title:'¡Listo!',text:'Contrato generado correctamente',color:'success',position:'bottom-center',icon:'done'})
					var downloadLink = document.createElement("a");
                    if(this.contrato <= 17 || this.contrato == 22 || this.contrato == 23  || this.contrato == 25 || this.contrato == 27 || this.contrato == 29 || this.contrato == 30) {
                        downloadLink.href = 'data:application/pdf;base64,' + resolve.data;
                        downloadLink.download = 'Contrato ' + this.contrato + ' - PID ' + this.pid + '.pdf';
                    }else{
                        downloadLink.href = 'data:application/xml;binary,' + resolve.data;
                        downloadLink.download = 'Contrato ' + this.contrato + ' - PID ' + this.pid + '.xml';
                    }
					downloadLink.click();
                }).catch(error => {
                    this.$vs.notify({title:'¡ERROR!',text:'Algo salió mal...',color:'danger',position:'bottom-center',icon:'error'})
                });
            }
        }
    }
}
</script>

<style scoped>
    .vx-card {
        cursor: pointer !important;
        margin-bottom: 1rem !important;
    }

    .feedback button {
        padding: 14px !important;
        padding-left: 5px !important;
    }
    .investorsPrograms button {
        padding: 5.5px !important;
    }
</style>